import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SessionStorageService } from '../../../../core/services/web-storage';

const sessionStorageKey = 'user_email_signature';

@Injectable({
    providedIn: 'root'
})
/** Service para manipular a assinatura de e-mail do usuário */
export class UsuarioEmailAssinaturaService {
    /** Subject de mudanças na URL da assinatura de e-mail do usuário */
    private subject = new Subject<string>();

    constructor(private sessionStorageService: SessionStorageService) {}

    /** Retorna o subject de mudanças na URL da assinatura de e-mail do usuário */
    getSubject(): Subject<string> {
        return this.subject;
    }

    /** Notifica os observers de mudanças na URL da assinatura de e-mail do usuário */
    next(urlAssinaturaEmail: string) {
        if (urlAssinaturaEmail) {
            this.sessionStorageService.set(sessionStorageKey, urlAssinaturaEmail);
        } else {
            this.sessionStorageService.remove(sessionStorageKey);
        }

        this.subject?.next(urlAssinaturaEmail);
    }

    /** Retorna a URL da imagem da assinatura de e-mail do usuário */
    getUrl(): string {
        return this.sessionStorageService.get(sessionStorageKey);
    }
}
